/**
 * Show and hide conditional question groups on quote-only truss products.
 *
 * A group carries data-quote-reveal-for="<question key>" and
 * data-quote-reveal-values="<value|value>". It is visible only while the trigger
 * question's current value is one of those values; otherwise it stays hidden and
 * its fields are cleared so answers from a previous selection do not linger.
 *
 * Only runs where the theme rendered data-truss-quote-questions.
 */
(function () {
  var root = document.querySelector('[data-truss-quote-questions]');
  if (!root) return;

  // The questions sit inside the product form, whose action is /cart/add. With a
  // single visible text field the browser submits that form on Enter, which would
  // put a quote-only product in the cart. Nothing here is ever submitted.
  var productForm = root.closest('form');
  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });
  }

  var groups = root.querySelectorAll('[data-quote-reveal-for]');

  // A question is either radios, a select, or a single text input. Radios and the
  // select answer with their checked/selected value; an empty value means nothing
  // has been picked yet.
  function questionValue(key) {
    var question = root.querySelector('[data-quote-question="' + key + '"]');
    if (!question) return '';

    var radio = question.querySelector('input[type="radio"]:checked');
    if (radio) return radio.value;

    var select = question.querySelector('select');
    if (select) return select.value || '';

    var text = question.querySelector('input[type="text"]');
    if (text) return text.value || '';

    return '';
  }

  function revealValues(group) {
    var raw = group.getAttribute('data-quote-reveal-values') || '';
    return raw.split('|').map(function (value) { return value.trim(); });
  }

  function clearGroup(group) {
    Array.prototype.forEach.call(group.querySelectorAll('input, select'), function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });
  }

  function sync() {
    Array.prototype.forEach.call(groups, function (group) {
      var values = revealValues(group);
      var show = values.indexOf(questionValue(group.getAttribute('data-quote-reveal-for'))) !== -1;
      if (show) {
        group.hidden = false;
      } else {
        if (!group.hidden) clearGroup(group);
        group.hidden = true;
      }
    });
  }

  root.addEventListener('change', sync);
  // compute the same state once at load, in case the theme restores selections
  sync();

  // Build answers into the quote request link. The href already carries
  // quote_product; we only add quote_options. Visible questions answer with their
  // label and value, visible reveal groups answer per field using its <label>.
  var link = document.querySelector('[data-quote-request-link]');
  if (!link) return;

  function collectAnswers() {
    var parts = [];
    var nodes = root.querySelectorAll('[data-quote-question], [data-quote-reveal-for]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.hidden) return;

      if (el.hasAttribute('data-quote-reveal-for')) {
        Array.prototype.forEach.call(el.querySelectorAll('input[type="text"], select'), function (field) {
          var value = (field.value || '').replace(/\|/g, '');
          if (!value) return;
          var name = '';
          if (field.id) {
            var fieldLabel = el.querySelector('label[for="' + field.id + '"]');
            if (fieldLabel) name = (fieldLabel.getAttribute('data-quote-name') || fieldLabel.textContent).replace(/\s+/g, ' ').trim();
          }
          if (!name) return;
          parts.push(name + ': ' + value);
        });
        return;
      }

      var label = el.getAttribute('data-quote-label');
      if (!label) return;
      var value = (questionValue(el.getAttribute('data-quote-question')) || '').replace(/\|/g, '');
      if (value) parts.push(label + ': ' + value);
    });
    return parts.join(' | ');
  }

  function baseHref() {
    var base = link.getAttribute('data-quote-base-href');
    if (!base) {
      base = link.href;
      var qIdx = base.indexOf('?');
      if (qIdx !== -1) {
        var kept = [];
        Array.prototype.forEach.call(base.slice(qIdx + 1).split('&'), function (pair) {
          if (pair.indexOf('quote_options=') !== 0) kept.push(pair);
        });
        base = base.slice(0, qIdx) + (kept.length ? '?' + kept.join('&') : '');
      }
      link.setAttribute('data-quote-base-href', base);
    }
    return base;
  }

  function rebuildHref() {
    var options = collectAnswers();
    var base = baseHref();
    if (!options) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'quote_options=' + encodeURIComponent(options);
  }

  function requiredFailures() {
    var failed = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-quote-question][data-quote-required]'), function (question) {
      if (question.hidden) return;
      if (!questionValue(question.getAttribute('data-quote-question'))) failed.push(question);
    });
    return failed;
  }

  function errorTextElement() {
    var el = link.parentNode.querySelector('.truss-quote-error');
    if (!el) {
      el = document.createElement('div');
      el.className = 'truss-quote-error';
      el.textContent = root.getAttribute('data-error-text') || 'Please answer the required questions.';
      link.parentNode.appendChild(el);
    }
    return el;
  }

  function markQuestions(failed) {
    Array.prototype.forEach.call(root.querySelectorAll('.truss-quote-question--error'), function (question) {
      question.classList.remove('truss-quote-question--error');
    });
    Array.prototype.forEach.call(failed, function (question) {
      question.classList.add('truss-quote-question--error');
    });
  }

  function hideErrorText() {
    var el = link.parentNode.querySelector('.truss-quote-error');
    if (el) el.style.display = 'none';
  }

  link.addEventListener('pointerdown', function () {
    link.href = rebuildHref();
  });

  link.addEventListener('click', function (event) {
    link.href = rebuildHref();
    var failed = requiredFailures();
    markQuestions(failed);
    if (failed.length) {
      event.preventDefault();
      errorTextElement().style.display = 'block';
      failed[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      hideErrorText();
    }
  });

  root.addEventListener('change', function () {
    Array.prototype.forEach.call(root.querySelectorAll('.truss-quote-question--error'), function (question) {
      if (questionValue(question.getAttribute('data-quote-question'))) {
        question.classList.remove('truss-quote-question--error');
      }
    });
    if (!requiredFailures().length) hideErrorText();
  });
})();